import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { navItems } from './navigation-items';
import { Router } from '@angular/router';

@Component({
	selector: 'app-side-nav',
	templateUrl: './side-nav.component.html',
	styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit, OnChanges {
	@Output() toggleClicked: EventEmitter<void> = new EventEmitter<void>();
	@Input() homeLink: any;
	@Input() isMenuCollapsed: boolean = false;

	navItems = navItems.map(item => ({ ...item, isOpen: false }));
	constructor(private router: Router) { }

	ngOnInit(): void {
		this.navItems.forEach(item => {
			if (item.children && item.children.length > 0) {
				// Check if any child matches the current URL
				item.isOpen = item.children.some(child => this.router.url.includes(child.routerLink));
			} else {
				// Check the parent's routerLink
				item.isOpen = this.router.url.includes(item.routerLink);
			}
		});
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['isMenuCollapsed'] && changes['isMenuCollapsed'].currentValue === true) {
			// Close all dropdown items when menu is collapsed
			this.navItems.forEach(item => {
				if (item.dropdown) {
					item.isOpen = false;
				}
			});
		}
	}
}